import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgPolice(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="5 -4 14 24" {...props}>
      <path
        d="M17.501 14c.605 0 1.095.49 1.095 1.095V16H5.508v-.905c0-.605.49-1.095 1.095-1.095zM11.975 3c2.991 0 5.5 2.258 5.813 5.233L18.289 13H5.661l.502-4.767A5.845 5.845 0 0111.975 3zm-.09 2c-1.161 0-2.086.28-2.779 1.634-.517 1.01-.564 2.198-.516 3.66.013.406.291.722.621.705.33-.016.574-.39.574-.763 0-1.189-.04-1.978.27-2.683.397-.903 1.021-1.141 1.83-1.141.33 0 .564-.246.576-.651.011-.406-.202-.761-.576-.761zM5.87 2.121l1.379 1.43-.87.89L5 3.012l.87-.89zm12.26-.026l.87.89-1.378 1.43-.87-.891 1.378-1.43zM12.614 0v2h-1.227V0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Police')(SvgPolice);
